const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
  }),
  info: {
    minHeight: '150px',
    '& h3': {
      marginTop: 5,
      marginBottom: 5,
    }
  },
  orangeButton:{
    backgroundColor: theme.palette.accent,
    color:'white',
    '&:hover': {
      backgroundColor: '#fd5622',
    },
  },
  uppercase: {
    textTransform: 'uppercase',
    '& b': {
      textTransform: 'none'
    }
  },
  h3:{
    marginBottom:'10px',
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/settings/fiberlimits/styles.js